import {Component, input, computed} from '@angular/core';
import {ReservationTrajetDto} from '../../dto/reservation-trajet.dto';
import {StatutsReservationTrajet} from '../../models/statut-reservation-trajet.enum';

@Component({
	selector: 'app-ligne-reservation-trajet',
	templateUrl: './ligne-reservation-trajet.component.html',
	styleUrl: './ligne-reservation-trajet.component.scss'
})
export class LigneReservationTrajetComponent {
	// Inputs
	reservation = input.required<ReservationTrajetDto>();

	// Computed
	cleTraduction = computed(() => StatutsReservationTrajet.get(this.reservation().statutReservation).cleTraduction);
	couleur = computed(() => StatutsReservationTrajet.get(this.reservation().statutReservation).couleur);

	constructor() {
	}
}
